import { render, staticRenderFns } from "./JobRequestUpdate.vue?vue&type=template&id=31dd6c1c&scoped=true&"
import script from "../../../services/applicant/job_request/job-request-update.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/job_request/job-request-update.js?vue&type=script&lang=js&"
import style0 from "./JobRequestUpdate.vue?vue&type=style&index=0&id=31dd6c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd6c1c",
  null
  
)

export default component.exports